import { useEffect } from 'react';
import { withLayout } from 'hocs';
import { Col, Row, Container } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import BarMobile from 'pages/Header/Content/components/BarMobile';
import ReviewCards from './ReviewsCard';
import { ReviewListv2 } from './listOfReviews2';
import styles from './styles.module.scss'

const Review = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const history = useHistory();
    const btnRegresar = () => history.goBack();

    return (
        <section className="opinion-section">
            <BarMobile
                pageName='Opiniones de los clientes'
                marginBottom="32px"
            />
            <Container style={{ maxWidth: '1500px' }}>
                <div onClick={btnRegresar} aria-label="Regresar" className={`${styles['nav-desk']} btnRegresar`}>
                    <strong>&#8592;</strong> Regresar
                </div>
                <Row>
                    <Col lg={4} md={12} className="mb-4">
                        <ReviewCards />
                    </Col>
                    <Col lg={8} md={12} className="mb-4">
                        <div className={`text-center ${styles.title}`} >
                            <h4 className="mb-5"><b>Opiniones de los clientes</b></h4>
                        </div>
                        <ReviewListv2 />
                    </Col>
                </Row>
            </Container>
        </section>

    );
};

export default withLayout(Review);
